import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, createStore } from 'redux';

import { Provider } from 'react-redux'
import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'Root';
import RootReducer from 'store/reducers/RootReducer';
import RootSaga from 'store/sagas/RootSaga';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';

// Output build version
console.debug(`Starting Compliancy App, rev. ${process.env.REACT_APP_BUILD_REVISION}`);

// Setup store
const sagaMiddleware = createSagaMiddleware();
const browserHistory = createBrowserHistory();
export const store = createStore(
  RootReducer(browserHistory),
  applyMiddleware(
    routerMiddleware(browserHistory),
    sagaMiddleware,
    logger
  )
);

// window._reduxStore = store;

// Init our root saga
sagaMiddleware.run(RootSaga);

// Inject redux-wrapped Root node
ReactDOM.render((
  <Provider store={store}>
      <Root history={browserHistory} />
  </Provider>
), document.getElementById('root'));
